import classNames from "classnames";
import { VStack } from "@design-system/VStack/VStack";
import { noop } from "@common/helpers/function";
import { useMemo } from "react";
import { OverPageCTA } from "@design-system/Banner/OverPageCTA";
import { FLAT_RATE_PLANS } from "@common/flatRateBilling";
import { BlurOverlay } from "@components/settings/Plans/BlurOverlay";
import { UpgradeCta } from "@components/settings/Plans/UpgradeCta";
import { useCanConnectIntegrations } from "@hooks/useCanConnectIntegrations";
import { generateMockBills, mockBillStats } from "@helpers/bills";
import { BillStats } from "./BillStats";
import { defaultBillsView } from "./views/defaultBillViews";
import { BillsView } from "./views/billsView/BillsView";
import styles from "./BillPageContent.module.scss";
import {
    BILL_CONNECT_CTA_TITLE,
    BILL_CONNECT_CTA_SUBTITLE,
    BillConnectButtons,
} from "./billConnectCta";

export const BillsConnectOverlay: React.FC = () => {
    const bills = useMemo(() => generateMockBills(10), []);
    const canConnectIntegrations = useCanConnectIntegrations();

    return (
        <>
            <div className={styles.ctaContainer}>
                {canConnectIntegrations ? (
                    <OverPageCTA
                        title={BILL_CONNECT_CTA_TITLE}
                        subtitle={BILL_CONNECT_CTA_SUBTITLE}
                        cta={<BillConnectButtons />}
                    />
                ) : (
                    <UpgradeCta
                        title={
                            <>
                                Bill integrations are available on the{" "}
                                <span className="text-blue-600">Basic</span>{" "}
                                plan
                            </>
                        }
                        subtitle={BILL_CONNECT_CTA_SUBTITLE}
                        plan={FLAT_RATE_PLANS.BASIC}
                    />
                )}
            </div>
            <VStack
                gap={24}
                className={classNames(
                    styles.billContainer,
                    "p-0 overflow-y-hidden",
                )}
            >
                <BillStats
                    filters={{}}
                    setFilters={noop}
                    billStats={mockBillStats}
                />
                <BillsView bills={bills} view={defaultBillsView} />
            </VStack>
            <BlurOverlay />
        </>
    );
};
